module.exports = __webpack_public_path__ + "static/img/12.bd89739.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/anniversary/img/12.png
// module id = 7VH9
// module chunks = 0